import { calculateAvailability } from '@opanuj/shared/slots';
import { ref } from 'firebase/database';
import { Registration } from '@opanuj/shared/types';
import { useDatabase } from '../../hooks/useDatabase';
import { useMemo } from 'react';
import { useObjectVal } from 'react-firebase-hooks/database';
import { useOffer } from '../../hooks/useOffer';
import { useSlots } from '../../hooks/useSlots';
import { useTeachers } from '../../hooks/useTeachers';

export type useAvailabilityProps = {
	code: string;
	locations: string[];
};

const useAvailability = ({ code, locations }: useAvailabilityProps) => {
	const database = useDatabase();
	const [slots, slotsLoading, slotsError] = useSlots();
	const [teachers, teachersLoading, teachersError] = useTeachers();
	const [offer, offerLoading, offerError] = useOffer();
	const [registrations, registrationsLoading, registrationsError] = useObjectVal<{ [id: string]: Registration }>(ref(database, 'bookings'));

	const isLoading = slotsLoading || teachersLoading || offerLoading || registrationsLoading;
	const error = slotsError || teachersError || offerError || registrationsError;

	const data = useMemo(() => {
		if (isLoading) return [];
		if (!slots || !teachers || !offer) return [];

		return calculateAvailability(
			{
				slots: slots ?? {},
				teachers: teachers ?? {},
				offer: offer ?? {},
				registrations: registrations ?? {},
			},
			{
				code: String(code).replace(/_/g, ' '),
				locations,
			}
		);
	}, [slots, teachers, offer, registrations, code, locations, isLoading]);

	return { isLoading, error, data };
};

export default useAvailability;